export default "__VITE_ASSET__iwSLHd3$__"